import React from "react";
import { Slider } from "./Slider";
import { SliderConfig } from "../../types/sliderConfig";

type MultipleSlidersProps<T, K extends keyof T & string> = {
  tempFilters: Pick<T, K>;
  setTempFilters: (update: Partial<Pick<T, K>>) => void;
  sliderConfigs: SliderConfig<K>[];
};

const MultipleSliders = <T, K extends keyof T & string>({
  tempFilters,
  setTempFilters,
  sliderConfigs,
}: MultipleSlidersProps<T, K>) => {
  return (
    <>
      {sliderConfigs.map(({ key, label, min, max }) => (
        <Slider
          key={key}
          value={tempFilters[key] as unknown as number}
          onChange={(val) =>
            setTempFilters({ [key]: val } as Partial<Pick<T, K>>)
          }
          min={min}
          max={max}
          label={label}
        />
      ))}
    </>
  );
};

export default MultipleSliders;
